module.exports = __webpack_public_path__ + "media/images/athletes/1441-bfb2a08f61f3b73753243a7b3f5e5669.png";